import {
  OBJECT_TYPE_ASSETS,
  OBJECT_TYPE_COLLECTIONS,
} from '@iconik-io/iconik-api/src/types/object_types';

import { DEFAULT_CATEGORY_NAME } from '../../../constants/metadata';
import type {
  CategoryObjectType,
  MetadataMetadataCategorySchemaPatched,
} from './types';

export const objectTypeCategoriesSupport = new Set<CategoryObjectType>([
  OBJECT_TYPE_ASSETS,
  OBJECT_TYPE_COLLECTIONS,
]);

const systemCategories: Record<CategoryObjectType, Set<string>> = {
  assets: new Set([DEFAULT_CATEGORY_NAME]),
  collections: new Set([DEFAULT_CATEGORY_NAME]),
  segments: new Set(['generic', 'tag']),
  search: new Set([DEFAULT_CATEGORY_NAME]),
  custom_actions: new Set([DEFAULT_CATEGORY_NAME]),
};

export const isSystemCategory = (
  category: MetadataMetadataCategorySchemaPatched,
): boolean =>
  category.object_type
    ? systemCategories[category.object_type].has(category.name)
    : false;

export const getCategoryLabel = (
  category: MetadataMetadataCategorySchemaPatched,
): string => (isSystemCategory(category) ? 'Default' : category.label);
